import React from 'react';
import { stats } from '../../data/artTherapy';
export function StatsGrid() {
  return <section aria-label="A kézikönyv számokban" className="bg-peach py-6 md:py-10" data-id="element-265" data-mp="1f024xd8ty47p">
      <dl className="mx-auto grid max-w-4xl grid-cols-2 gap-3 px-5 md:grid-cols-4 md:gap-4" data-id="element-266" data-mp="1szl1r9w6xt4p">
        {stats.map(s => <div key={s.label} className="flex flex-col items-center justify-center rounded-3xl border border-lavender-line bg-white px-3 py-6 text-center" data-id="element-267" data-mp="1oxg9aehhb2jn">
            <dd className="font-display text-3xl font-extrabold leading-none tracking-tight text-lavender" data-id="element-268" data-mp="w9u9zifaak2l">{s.value}</dd>
            <dt className="mt-3 text-[13px] font-bold uppercase tracking-[0.1em] text-body" data-id="element-269" data-mp="1a1qx1823i3s4">{s.label}</dt>
          </div>)}
      </dl>
    </section>;
}